import {isValid} from 'date-fns';
import {getTimeFromDate} from 'platform/components';

import {parseDate, Nullish} from 'shared/web';

/**
 * @about Utility function to get locale time in HH:MM from ISO string
 * @returns Locale time in HH:MM format
 * @example
 *  const date = 2023-06-30T15:30:00Z
 *
 *  const requestExpiresAtTime = getDefaultRequestExpiresAtTime(date);
 *  /=>'17:30'
 */
export const getDefaultRequestExpiresAtTime = (date: string | Nullish) => {
  if (!date) {
    return;
  }

  const parsed = parseDate(date);

  return isValid(parsed) ? getTimeFromDate(parsed) : undefined;
};
